/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState = {
  quickAutomationData: {},
}

export const CreateQuickAutomation: any = createAsyncThunk(
  'CreateQuickAutomation',
  async (data: any, thunkApi: any) => {
    // thunkApi.dispatch(startLoadding())
    const response = await axios.post(`${API_URL}automation`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    response.data.status == true
      ? toast.success(response.data.message)
      : toast.error(response.data.message)
    thunkApi.dispatch(GetAutomationList())
    return response.data
  }
)

export const GetAutomationList: any = createAsyncThunk(
  'GetAutomationList',
  async (data: any, thunkApi) => {
    const response = await axios.get(`${API_URL}automation`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    return response.data
  }
)

export const EditQuickAutomation: any = createAsyncThunk(
  'EditQuickAutomation',
  async (data: any, thunkApi) => {
    const response = await axios.put(`${API_URL}automation/${data?.id}`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    response.data.status == true
      ? toast.success(response.data.message)
      : toast.error(response.data.message)
    thunkApi.dispatch(GetAutomationList())
    return response.data
  }
)

export const DeleteQuickAutomation: any = createAsyncThunk(
  'DeleteQuickAutomation',
  async (data: any, thunkApi) => {
    const response = await axios.delete(`${API_URL}automation/${data}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    response.data.status == true
      ? toast.success(response.data.message)
      : toast.error(response.data.message)
    thunkApi.dispatch(GetAutomationList())
    return response.data
  }
)

const AutomationSlice = createSlice({
  name: 'AutomationSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GetAutomationList.fulfilled, (state, action) => {
      return {...state, quickAutomationData: action?.payload}
    })
  },
})

export const getQuickAutomationData = (state: any) => state?.automation?.quickAutomationData?.data

export default AutomationSlice.reducer
